<div
  class="form-field"
  [class.label-top]="labelPosition === 'top'"
  [class.label-left]="labelPosition === 'left'"
  [class.label-right]="labelPosition === 'right'"
  [class.label-bottom]="labelPosition === 'bottom'"
>
  @if (label) {
  <label class="form-label" [for]="inputId">{{ label }}</label>
  }
  <input
    class="form-control"
    [id]="inputId"
    [type]="type === 'obscured' ? 'password' : type"
    [value]="value"
    (input)="onInput($event)"
    [placeholder]="placeholder || label"
    [attr.autocomplete]="autocomplete || null"
    [disabled]="disabled"
    [class.has-error]="hasError"
  />
  @if (errorMessage) {
  <span class="error-message">{{ errorMessage }}</span>
  }
</div>
